// Uhren-Offset gegen die Server-Zeit (R2/1.3). Der Server liefert serverNow in jedem AttendanceState; wir
// merken uns die Differenz (server − lokal) und stempeln stamped_at SERVERKORRIGIERT. So bleibt die
// serverseitige Provenienz-Ableitung (live ≤5min / outbox_replay ≤72h / correction >72h) belastbar, auch wenn
// die Uhr des Werkstatt-Tablets falsch geht — sonst würde ein Live-Tipp mit schiefer Uhr fälschlich als
// Nachzügler klassifiziert. Rein in-memory + best effort: ohne je gesehenen serverNow ist der Offset 0
// (= ehrliche Geräte-Zeit), und der Server clampt Zukunfts-Skew ohnehin nach live (lehnt nie ab).

let offsetMs = 0

/** Aus einem frischen Server-Zeitpunkt den Offset (server − lokal) nachziehen. No-op bei fehlendem/ungültigem Wert. */
export function noteServerNow(serverNow: number | null | undefined): void {
  if (typeof serverNow === 'number' && Number.isFinite(serverNow)) offsetMs = serverNow - Date.now()
}

/** Serverkorrigierte „jetzt"-Zeit (epoch ms) — Basis für stamped_at beim Stempeln/Enqueue. */
export function serverAdjustedNow(): number {
  return Date.now() + offsetMs
}

/** Nur für Tests: den Offset zurücksetzen. */
export function __resetServerClock(): void {
  offsetMs = 0
}
